import { Box, BoxProps, Spacer, TextNew } from '@jfs/ui-new'
import NativeBreadcrumb from '../../../comps/NativeBreadCrumb'
import { Routes } from '../../../nav/routes'

const breadCrumbConstants = [{ to: Routes.PAYMENT_LINKS, label: 'Payment Links' }, { label: 'Create Payment Link' }]

interface RenderPaymentFormHeader {
  navigation: any
  reviewPaymentLinkSelected: boolean
}

export const RenderPaymentFormHeader = ({ navigation, reviewPaymentLinkSelected }: RenderPaymentFormHeader) => {
  return (
    <Box {...styles.header}>
      <NativeBreadcrumb navigate={navigation.navigate} crumbs={breadCrumbConstants} />
      <Spacer size={16} />
      <TextNew type={'titleMedium20'}>
        {reviewPaymentLinkSelected ? 'Review Payment Link' : 'Create Payment Link'}
      </TextNew>
    </Box>
  )
}

const styles = {
  header: {
    pb: 16,
    pt: 4,
    backgroundColor: 'WHITE',
    alignItems: 'flex-start',
  } as BoxProps,
}
